//配送方法選択時実行関数
// 戻り値 : なし
const checkShippingMethod = () => {
  
  //配送方法選択
  const shippingRadioButtons = document.getElementsByName('attributes[shipping]');
  for (const radioButton of shippingRadioButtons) {

    //配送方法選択ラジオボタン changeイベント
    radioButton.addEventListener('change', (e) => {
      //初期選択状態 NetXXチェックアウトボタン
      if (radioButton.checked && document.getElementById('end-user').value !== '' && document.getElementById('sam-shipping-address-no').value != '') {
        document.getElementsByClassName('purchase-benefits')[0].style = 'border:none;';
        document.getElementsByClassName('purchase-benefits')[0].disabled = false;
      }
      
      //配送方法とエンドユーザーが選択されている場合
      if (radioButton.checked && document.getElementById('end-user').value !== '') {
        document.getElementsByClassName('cart-recap__checkout')[0].style = '';
        document.getElementsByClassName('cart-recap__checkout')[0].disabled = false;
      }

    });
  }
}

//エンドユーザー選択時実行関数
// 戻り値 : なし
const checkEnduser = () => {
  //エンドユーザー選択
  document.getElementById('end-user').addEventListener('change',(e) => {

    const shippingRadioButtons = document.getElementsByName('attributes[shipping]');
    let checkShippingRadioButtons = false;
    for (const radioButton of shippingRadioButtons) {
      if (radioButton.checked) {
        checkShippingRadioButtons = true;
        break;
      }
    }

    if (checkShippingRadioButtons && document.getElementById('end-user').value !== '' && document.getElementById('sam-shipping-address-no').value != '') {
      document.getElementsByClassName('purchase-benefits')[0].style = 'border:none;';
      document.getElementsByClassName('purchase-benefits')[0].disabled = false;
    } else {
      document.getElementsByClassName('purchase-benefits')[0].style = 'border:none; pointer-events:none; opacity: 0.65;';
      document.getElementsByClassName('purchase-benefits')[0].disabled = true;
    }
    
    if (checkShippingRadioButtons && document.getElementById('end-user').value !== '') {
      document.getElementsByClassName('cart-recap__checkout')[0].style = '';
      document.getElementsByClassName('cart-recap__checkout')[0].disabled = false;
    } else {
      document.getElementsByClassName('cart-recap__checkout')[0].style = 'pointer-events:none; opacity: 0.65;';
      document.getElementsByClassName('cart-recap__checkout')[0].disabled = true;
    }
    
  });
}

//配送先住所選択時実行関数
// 戻り値 : なし
const checkShippingAddress = () => {

  document.getElementById('sam-shipping-address-no').addEventListener('change',() => {

    const shippingRadioButtons = document.getElementsByName('attributes[shipping]');
    let checkShippingRadioButtons = false;
    for (const radioButton of shippingRadioButtons) {
      if (radioButton.checked) {
        checkShippingRadioButtons = true;
        break;
      }
    }
    
    if (checkShippingRadioButtons && document.getElementById('end-user').value !== '' && document.getElementById('sam-shipping-address-no').value !== '') {
      document.getElementsByClassName('purchase-benefits')[0].style = 'border:none;';
      document.getElementsByClassName('purchase-benefits')[0].disabled = false;
    } else {
      document.getElementsByClassName('purchase-benefits')[0].style = 'border:none; pointer-events:none; opacity: 0.65;';
      document.getElementsByClassName('purchase-benefits')[0].disabled = true;
    }
    
  });
}

//初期実行関数
// 戻り値 : なし
const tciInitCart = (() => {

  //配送方法選択 changeイベント
  checkShippingMethod();

  //エンドユーザー選択 changeイベント
  checkEnduser();

  //配送先住所選択 changeイベント
  checkShippingAddress();
  
})();
